<template>
	<label :class="`omapi-${type}`" ref="label" :title="titleTag">
		<slot name="description"></slot>
		<input
			:type="type"
			:value="value"
			:name="name"
			:checked="checked || selected"
			@keydown.space="$emit('input', $event)"
			v-bind="$attrs"
			v-on="$listeners"
			ref="input"
		/>
		<span :class="fauxInputClass"></span>
		<slot>{{ label }}</slot>

		<span v-if="$slots.help || help"  :class="`omapi-${type}__helper`">
			<slot name="help">
				{{ help }}
			</slot>
		</span>
	</label>
</template>

<script>
export default {
	inheritAttrs : false,
	props        : {
		/**
		 * The input radio type
		 */
		type : {
			type    : String,
			default : 'radio',
		},
		/**
		 * The label value for the selectable input.
		 * Can optionally use the slot.
		 */
		label      : String,
		/**
		 * Optional help text for this option.
		 * Can optionally use the help slot.
		 */
		help       : String,
		/**
		 * Optional title tag text for this option label.
		 */
		titleTag   : String,
		/**
		 * The name for this option.
		 */
		name       : String,
		/**
		 * The value for this option.
		 */
		value      : String,
		/**
		 * Additional classes for `omapi-${type}__input`
		 */
		inputClass : String,
		/**
		 * Wether this option is checked/selected (they both work)
		 */
		checked    : Boolean,
		/**
		 * Wether this option is checked/selected (they both work)
		 */
		selected   : Boolean,
	},
	computed : {
		fauxInputClass () {
			let classes = `omapi-${this.type}__input`

			if (this.inputClass) {
				classes += ' ' + this.inputClass
			}

			return classes
		},
	},
}
</script>
